import { fork, takeEvery } from "redux-saga/effects";

import CampaignConstants from "modules/campaign/constants";
import CampaignSagas from "modules/campaign/sagas";

function* watchListSearchCampaign() {
  yield takeEvery(CampaignConstants.LIST_SEARCH_CAMPAIGN, CampaignSagas.ListSearchCampaign);
}

function* watchListTopKeyword() {
  yield takeEvery(CampaignConstants.LIST_TOP_KEYWORD, CampaignSagas.ListTopKeyword);
}

function* watchListDisplayCampaign() {
  yield takeEvery(CampaignConstants.LIST_DISPLAY_CAMPAIGN, CampaignSagas.ListDisplayCampaign);
}

function* watchListTopAudience() {
  yield takeEvery(CampaignConstants.LIST_TOP_AUDIENCE, CampaignSagas.ListTopAudience);
}
function* watchListTopPlacement() {
  yield takeEvery(CampaignConstants.LIST_TOP_PLACEMENT, CampaignSagas.ListTopPlacement);
}

export default [
  fork(watchListSearchCampaign),
  fork(watchListTopKeyword),
  fork(watchListDisplayCampaign),
  fork(watchListTopAudience),
  fork(watchListTopPlacement),
];
